import { useQuery } from '@tanstack/react-query';
import { sessionQuery } from '@/api/session';

export function useSession() {
  const q = useQuery(sessionQuery);
  return {
    session: q.data,
    user: q.data?.user,
    isPlatformAdmin: q.data?.user?.isPlatformAdmin ?? false,
  };
}
